// extracted by mini-css-extract-plugin
module.exports = {"main":"TextSwitcher__main___3qMIn","active":"TextSwitcher__active___2fn1D"};